// Port of api/fuel/app/classes/filter/search/games/filters/query/game/age/official.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'game.age.official',
	priority: 49,
	require: function(config, filter) {
		return rangeActive(filter.age && filter.age.official, 2, 21)
	},
	run: function(config, filter, data, query) {
		if (filter.age.official.from > 2) query.where('g.game_age_official', '>=', filter.age.official.from)
		if (filter.age.official.to < 21) query.where('g.game_age_official', '<=', filter.age.official.to)
	}
}
